import { Components, Theme } from '@mui/material';

const muiTableCell: Components<Theme>['MuiTableCell'] = {
	styleOverrides: {
		root: ({ theme }) => ({
			...theme.typography.body3,
			borderBottom: `1px solid ${theme.palette.divider}`,
		}),
		head: ({ theme }) => ({
			...theme.typography.h6,
		}),
	},
};

export default muiTableCell;
